import { useMemo } from 'react';
import { toast } from 'react-toastify';

import { Alert } from 'components/alert';
import { getErrorMessage } from 'utils/error';
import type { AlertOptionsType } from 'types';

export const useAlert = () => {
  const showAlert = (message: string, options: AlertOptionsType) => {
    return toast(Alert, { data: { message, options } });
  };

  const handleError = (error: any) =>
    showAlert(getErrorMessage(error), { type: 'error' });

  const showSuccessAlert = (message: string, options?: AlertOptionsType) =>
    showAlert(message, { type: 'success', ...options });

  const showErrorAlert = (message: string, options?: AlertOptionsType) =>
    showAlert(message, { type: 'error', ...options });

  // The calm (not red) toast.
  const showInfoAlert = (message: string, options?: AlertOptionsType) =>
    showAlert(message, { type: 'info', ...options });

  return useMemo(
    () => ({
      handleError,
      showInfoAlert,
      showErrorAlert,
      showSuccessAlert,
    }),
    []
  );
};
